import { Flex, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from 'src/components/AuthHOC';
import {
  getProxySession,
  type ProxySession
} from 'src/components/ProxyUser/storage';

const getProxyRedirectUrl = (session: ProxySession): string => {
  if (session.role === 'author' && session.submissionId)
    return `/app/my-submissions/${session.submissionId}`;
  if (session.role === 'reviewer' && session.reviewId)
    return `/app/reviews/${session.reviewId}`;
  if (session.role === 'board-member' && session.returnUrl)
    return session.returnUrl;
  return '/app/home';
};

const Forbidden = () => {
  const { currentUser } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    const session = getProxySession();

    if (!session || session.returnUrl !== window.location.href) return;

    navigate(getProxyRedirectUrl(session), { replace: true });
  }, [navigate]);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100vh"
      backgroundColor="surfaceSecondaryFill"
      flexDirection="column"
      textAlign="center"
    >
      <Text textStyle="headingSection">
        You do not have access to this page. If you believe this is a mistake,
        please reach out to your administrator.
      </Text>
      <Text textStyle="headingItem" marginTop={4}>
        You are logged in as {currentUser.firstName} {currentUser.lastName}
      </Text>
    </Flex>
  );
};

export default Forbidden;
